import { AuthApi } from '../auth/authApi';
import { Singleton } from '@/decorators';
import { generateQueryString } from '@/libs';
import type {
  GetLastActivitesRequestDTO,
  GetLastActivitiesResponseDTO,
} from './DTOs';
import type { Result } from '@/types/result.interface';
import type { AppError } from '@/types/errors.interface';
import { wrapHttpCall } from '../utils/apiResultMapper';

/**
 * User API (Framework Agnostic)
 * 
 * Handles user activity operations.
 */
@Singleton
export class UserApi extends AuthApi {
  constructor() {
    super();
  }

  async getLastActivities(body: GetLastActivitesRequestDTO): Promise<Result<GetLastActivitiesResponseDTO, AppError>> {
    const queryString = generateQueryString({
      Take: body.take,
      LastLoadedSessionID: body.lastLoadedSessionId,
    });

    return wrapHttpCall(() => this.api.get<GetLastActivitiesResponseDTO>(
      `/UserActivity/GetLastActivities${queryString}`,
    ));
  }
}
